


















































import LoginButton from '@spa/components/pages/auth/login/components/button/LoginButton.vue'
import { AsLoginForm } from '@spa/components/pages/auth/login/components/mixin/as-login-form'
import LoadingMixin from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: { LoginButton },
})
export default class LoginWithoutIcon extends Mixins<AsLoginForm & LoadingMixin>(AsLoginForm, LoadingMixin) {
  @Prop({ required: true })
  /**
   * @see LoginPageProps.next
   * @see AsLoginForm.next
   */
  readonly next: string
}
